export default __webpack_public_path__ + "static/media/a023-2.e77eb12a.png";